"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Theme = require("../../Theme/Theme.variables");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // Context Component for Theme


var Theme = function Theme(_ref) {
  var children = _ref.children,
      brand = _ref.brand,
      breakpoints = _ref.breakpoints;
  return _react.default.createElement(_styledComponents.ThemeProvider, {
    theme: {
      brand: brand,
      breakpoints: breakpoints,
      space: _Theme.space
    }
  }, _react.default.createElement(_react.Fragment, null, " ", children, " "));
};

exports.Theme = Theme;
Theme.displayName = 'Theme'; // Prop Types

Theme.propTypes = {
  brand: _propTypes.default.string,
  // 'gentux', 'menguin'
  breakpoints: _propTypes.default.array,
  space: _propTypes.default.array
};
Theme.defaultProps = {
  brand: 'gentux',
  breakpoints: _Theme.breakpointsArray,
  space: _Theme.space
};